export const setCallFlows = (callFlows) => ({
    type: "SET_CALL_FLOWS",
    payload: callFlows,
  });

  export const setCallFlowsIds = (callFlowsIds) => ({
    type: "SET_CALL_FLOWS_IDS",
    payload: callFlowsIds,
  });